import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { TagsMutationKeys } from '../../constants'
import { UpdatePlayerTagDto, PlayerTagResponse } from '../../types'
import { updatePlayerTag } from '../services'

interface UpdatePlayerTagParams {
	id: string
	payload: UpdatePlayerTagDto
}

export default function useMutationUpdatePlayerTag(
	props?: UseBaseMutationOptions<PlayerTagResponse, UpdatePlayerTagParams>,
) {
	return useMutation({
		mutationKey: [TagsMutationKeys.UpdateTag],
		mutationFn: (params) => updatePlayerTag(params.id, params.payload),
		...props,
	})
}
